export default __webpack_public_path__ + "static/media/2.93c2d6e9.svg";